module.exports = __webpack_public_path__ + "img/guide-recipe.309c33b5.png";